export default {
  namespaced: true,
  state: {
    searchCompany: {
      buyer: {
        selectedCountry: ''
      },
      seller: {
        selectedCountry: ''
      }
    }
  },
  mutations: {
    setDefaultCountryForSearchCompany (state, value) {
      state.searchCompany.buyer.selectedCountry = value
      state.searchCompany.seller.selectedCountry = value
    }
  },
  actions: {
    setDefaultCountryForSearchCompany (context, value) {
      context.commit('setDefaultCountryForSearchCompany', value)
    }
  }
}
